import React, { FC } from "react";
import classes from "./style/UI_ITOModuleStikeController.module.css";

interface UI_ModuleStikeControllerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  position?: "left" | "right" | "center";
}
export const UI_ModuleStikeController: FC<UI_ModuleStikeControllerProps> = (
  props
) => {
  const { children, style, position } = props;
  return (
    <div className={classes.wrapperController} style={style}>
      <div style={{ textAlign: position || "left" }}>{children}</div>
    </div>
  );
};
